import type { SVGProps } from 'react'
const SvgSyNotification = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M12 1.25c-4.436 0-7.432 3.44-7.432 6.695 0 1.653-.36 2.26-.802 3S2.75 12.613 2.75 14.221l.002.064c.145 1.674 1.134 2.927 2.705 3.541s3.692.772 6.543.772 4.972-.16 6.543-.776c1.57-.615 2.56-1.868 2.705-3.537l.002-.064c0-1.608-.573-2.535-1.016-3.276-.442-.74-.802-1.347-.802-3 0-3.255-2.996-6.695-7.432-6.695m0 1.5c3.654 0 5.932 2.888 5.932 5.195 0 1.908.548 2.988 1.015 3.77.46.77.788 1.213.797 2.467-.112 1.212-.552 1.774-1.748 2.242-1.206.472-3.208.674-5.996.674s-4.79-.2-5.996-.67c-1.195-.467-1.635-1.028-1.748-2.246.009-1.254.336-1.696.797-2.467.467-.782 1.015-1.862 1.015-3.77C6.068 5.638 8.346 2.75 12 2.75"
				clipRule="evenodd"
			/>
			<path
				d="M9.018 20.299a.75.75 0 0 0-.057 1.06c1.636 1.821 4.363 1.801 5.984 0a.75.75 0 0 0-.054-1.058.75.75 0 0 0-1.059.054c-1.107 1.23-2.635 1.245-3.754 0a.75.75 0 0 0-1.06-.056"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyNotification
